
  window.ac = window.ac || {};
  ac.chatLink = document.querySelector("a[href='#chatinbox']");

  if (ac.chatLink) {
    ac.chatLink.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      function tryOpenChat(attempts = 0) {
        const chatEl = document.getElementById("ShopifyChat");

        if (chatEl && chatEl.shadowRoot) {
          const toggleBtn = chatEl.shadowRoot.querySelector("button.chat-toggle");
          if (toggleBtn) {
            toggleBtn.click();
            return;
          }
        }

        if (attempts < 20) {
          setTimeout(() => tryOpenChat(attempts + 1), 250);
        } else {
          console.warn("Shopify Chat not available after multiple attempts");
        }
      }

      tryOpenChat();
    });
  }

